module.exports = __webpack_public_path__ + "static/media/slurpalt.6954043e.png";